import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import GenericEntityCreator from '../../components/Common/GenericEntityCreator';

const CreateSignal: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = (createdEntity: any) => {
    console.log('Signal created:', createdEntity);
    navigate('/signals');
  };

  const handleCancel = () => {
    navigate('/signals');
  };

  return (
    <Box>
      {/* Breadcrumbs */}
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        sx={{ mb: 3 }}
      >
        <Link
          color="inherit"
          href="/signals"
          onClick={(e) => {
            e.preventDefault();
            navigate('/signals');
          }}
        >
          Signal Management
        </Link>
        <Typography color="text.primary">Create Signal</Typography>
      </Breadcrumbs>

      {/* Generic Entity Creator */}
      <GenericEntityCreator
        entityType="signal"
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </Box>
  );
};

export default CreateSignal;

